import {downloadJsonAsCSV} from '../../csv/utils'
import {ColumnTitlesKeys} from '../tasksTable/configurationMenu/constants'
import messageResource from "../../messageResource"
import _ from "underscore"
import {TaskSortBy} from '../constants'
import {DateFormat} from '../../date_format'
import {arrayToMap} from '../../atUtils'
import NumberFormatter from '../../number_formatter'
import {WorkflowStatusType} from '../../workflowStatus/constants'

const dateFormat = new DateFormat(window.SystemSettings.dateFormat)
const numberFormat = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

export function convertTaskListAndSaveAsCsv({projects, customers, tasks, billingTypes, workflowStatuses}, optionalColumns, isTWSEnabled) {
    const customerMap = arrayToMap(customers)
    const projectMap = arrayToMap(projects)
    const billingTypesMap = arrayToMap(billingTypes.list)
    const workflowStatusValueMap = {}
    const getWorkflowStatusValue = isTWSEnabled ? workflowStatusExtended : workflowStatusSimple
    workflowStatuses.forEach(item => workflowStatusValueMap[item.id] = getWorkflowStatusValue(item))

    const json = {
        columnNames: csvColumnNames(optionalColumns),
        columns: csvColumns(optionalColumns),
        table: csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap)
    }
    let fileName = messageResource.getMessage("task.list.export_name.csv", [new DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())])
    downloadJsonAsCSV([json], fileName)
}

function csvColumnNames(optionalColumns) {
    return {
        customer: messageResource.getMessage("common.Customer"),
        project: messageResource.getMessage("common.Project"),
        task: messageResource.getMessage("common.Task"),
        status: messageResource.getMessage("task.list.task_status"),
        ...csvOptionalColumnNames(optionalColumns)
    }
}

function csvOptionalColumnNames(optionalColumns) {
    return _.object(optionalColumns, _.map(optionalColumns, (item) => messageResource.getMessage(ColumnTitlesKeys[item])))
}

function csvColumns(optionalColumns) {
    return ["customer", "project", "task", "status", ...optionalColumns]
}

function csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap) {
    return _.map(tasks, (task) => {
        return {
            customer: nameWithArchivedMark(customerMap[task.customerId]),
            project: nameWithArchivedMark(projectMap[task.projectId]),
            task: task.name,
            status: workflowStatusValueMap[task.workflowStatusId],
            ...csvMapOptionalColumns(optionalColumns, task, billingTypesMap)
        }
    })
}

function csvMapOptionalColumns(optionalColumns, task, billingTypesMap) {
    let result = {}
    _.each(optionalColumns, (column) => {
        result[column] = optionalColumnMap[column](task, billingTypesMap)
    })
    return result
}

const optionalColumnMap = {
    [TaskSortBy.DEADLINE]: (task) => columnValue(task.deadline, formatDate),
    [TaskSortBy.ESTIMATE]: (task) => columnValue(task.estimatedTime, formatTimeDecimal),
    [TaskSortBy.LAST_TRACKING_DATE]: (task) => columnValue(task.lastTTDate, formatDate),
    [TaskSortBy.TYPE_OF_WORK]: (task, billingTypesMap) => billingTypeColumnValue(billingTypesMap[task.typeOfWorkId]),
    [TaskSortBy.CREATION_DATE]: (task) => formatDate(task.creationTimestamp),
    [TaskSortBy.SPENT_TIME]: (task) => formatTimeDecimal(task.spentTime),
}

function nameWithArchivedMark(entity) {
    return entity.archived ? entity.name + ' ' + messageResource.getMessage('common.archived') : entity.name
}

function workflowStatusSimple(status) {
    return messageResource.getMessage(status.type === WorkflowStatusType.OPEN ? "task.status.open" : "task.status.completed")
}

function workflowStatusExtended(status) {
    const statusPrefix = workflowStatusSimple(status)
    return `${statusPrefix}: ${status.name}`
}

function columnValue(val, format = (val) => val) {
    return val ? format(val) : ''
}

function formatDate(val) {
    return dateFormat.formatDate(Date.parseJSONDate(val))
}

function formatTimeDecimal(val) {
    return numberFormat.format(val / 60)
}

function billingTypeColumnValue(billingType) {
    const category = messageResource.getMessage(billingType.billable ? 'billing_type.billable' : 'billing_type.non_billable')
    return `${category}: ${billingType.name}`
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/utils.js